import axios from 'axios';

const backendBaseUrl = process.env.REACT_APP_BACKEND_URL;

async function fetchCurrency() {
    try {
        const response = await axios.get(backendBaseUrl + "currencies/");

        return parseCurrenciesData(response.data);
    }    
    catch (error) {
        alert(error);
        return [];
    }
}

async function parseCurrenciesData(data) {
    const parsedCurrencies = data.map(currency => {
        return {
            code: currency.currencyCode,
            rate: currency.rate,
            symbol: currency.symbol,
            decimals: currency.decimals,
        }
    });

    return parsedCurrencies;
}

export {fetchCurrency};